import {Game} from "../Game";
import {gsap} from "gsap";
import {GameUtils} from "../utils/GameUtils";
import {EnhancerEffects} from "../enums/Enum";
import {Sound} from "../sound/Sound";

export class EnhancerCell extends PIXI.Container {
    private _spine: PIXI.spine.Spine;
    private _fireFrameCount: number = 0;
    private _total: number;
    private _isOpen: boolean;
    private _effects: PIXI.spine.Spine;
    private _reelId: number;
    private _lineSpine: PIXI.spine.Spine;

    constructor(reelID: number, effect: PIXI.spine.Spine) {
        super();
        this._reelId = reelID;
        this.name = "EnhancerCell_" + reelID;
        this._effects = effect;
        this.init(reelID);
    }

    public open(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(gsap.to([this._lineSpine], {duration: 0.2, alpha: 1}));
        tl.add(() => {
            this._isOpen = true;
            this._reelId === 1 && Game.soundPlayer.playSound(Sound.ENHANCER_OPEN);
        });
        tl.add(() => this.play(EnhancerEffects.OPEN, false));
        tl.add(gsap.to([this._lineSpine], {duration: 0.1, alpha: 0}), "0.25");
        tl.add(GameUtils.createTimelineForAnimation(this._spine, 0, "open", false).timeScale(1.2), "0.18");
        tl.to(this, {duration: 0.01, alpha: 0});
        tl.add(() => {
            this._effects.visible = false;
        });
        return tl;
    }

    public close(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this._isOpen = false;
        });
        tl.to(this, {duration: 0.001, alpha: 1});
        tl.add(GameUtils.createTimelineForAnimation(this._spine, 0, "close", false));
        tl.add(() => {
            this._spine.state.setAnimation(0, "normal", true);
            this._spine.autoUpdate = true;
            gsap.to([this._lineSpine], {duration: 0.01, alpha: 1});
        });
        return tl;
    }

    public reSetLines(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to(this._lineSpine, {duration: 0.001, alpha: 1});
        return tl;
    }


    public play(effectName: EnhancerEffects, isLoop: boolean = false): void {
        this._effects.state.setAnimation(0, effectName, isLoop);
        this._effects.visible = true;
    }

    public setDarkMode(isDark: boolean): void {
        const tintVal: number = isDark ? 0x777676 : 0xffffff;
        this._spine.tint = tintVal;
        this._lineSpine.tint = tintVal;
    }

    private reSetEffects(): void {
        this._effects.state.clearTracks();
        this._effects.state.setEmptyAnimations(0);
        this._effects.visible = false;
    }

    private setTotal(reelId: number): void {
        if (reelId === 2) {
            this._total = 8;
        } else if (reelId === 3) {
            this._total = 6
        } else {
            this._total = 4;
        }
    }

    private init(reelId: number): void {
        this._lineSpine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("enhancerLine" + reelId));
        this._lineSpine.state.setAnimation(0, "normal", false);
        this._spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("enhancer" + reelId));
        this._spine.state.setAnimation(0, "normal", true);
        this._spine.autoUpdate = true;
        this.setTotal(reelId);
        this.addChild(this._spine, this._lineSpine);
        this.fireFrameCount = 0;
        this._lineSpine.alpha = 1;
    }

    get isOpen(): boolean {
        return this._isOpen;
    }

    public setActive():void{
        this._lineSpine.state.setAnimation(0, (this._fireFrameCount + 1) + "", false);
    }

    set fireFrameCount(value: number) {
        this._fireFrameCount = Math.min(value, this._total);
        if (this._fireFrameCount === 0) {
            this._lineSpine.state.setAnimation(0, "normal", false);
        } else {
            this._lineSpine.state.setAnimation(0, this._fireFrameCount + "", false);
            this._lineSpine.alpha = 0.75;
        }
    }
}